import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const AnalyzeReportsContainer = Loadable({
  loader: () => import('../components/analyze/AnalyzeReportsContainer')
});
export const AsyncAnalyzeReportsContainer = () => /*#__PURE__*/_jsx(AnalyzeReportsContainer, {});